import React, {useEffect} from "react";
import {Card} from "antd";
import SearchForm from "./SearchForm";
import StockList from "./StockList";
import PssDetailModal from "./PssDetailModal";
import StockDetailDrawer from "./StockDetailDrawer";
import ShiftDrawer from "./ShiftDrawer";
import {useModel, useModelDispatchers} from "../../../models";

export default function () {
    const {

        getBrandDict,
        getEngineTypeDict,
        getMaterialUnitDict,
        getMaterialSortDict,

        getOrgDict,
        getWarehouseDict,
        getAreaDict,
        getShelveDict,
        getPositionDict,

    } = useModelDispatchers("cmDict");

    useEffect(() => {

        getBrandDict();
        getEngineTypeDict();
        getMaterialUnitDict();
        getMaterialSortDict();

        getOrgDict();
        getWarehouseDict();
        getAreaDict();
        getShelveDict();
        getPositionDict();

    }, []);

    return (
        <>
            <Card
                bordered={true}
                className="margin-top-8"
            >
                <div
                    style={{
                        margin: "8px 20px"
                    }}
                >
                    <SearchForm/>
                </div>
            </Card>
            <Card
                bordered={true}
                className="margin-top-8"
            >
                <StockList/>
            </Card>
            <PssDetailModal/>
            <StockDetailDrawer/>
            <ShiftDrawer/>
        </>
    )
}